import type { ComponentTheme } from '../types/component-theme';

import { StatePanelStates } from './constants/state-panel';

const statePanelRingStyles = 'absolute inset-0 animate-state-panel-ring rounded-full border-2';

export default {
    slots: {
        root: 'relative mb-7 flex h-26 w-26 items-center justify-center',
        ring: statePanelRingStyles,
        delayedRing: `${statePanelRingStyles} [animation-delay:0.7s]`,
        glow: 'absolute h-[130%] w-[130%] animate-state-panel-glow rounded-full',
        errorGlow:
            'absolute h-[130%] w-[130%] rounded-full ' +
            'bg-[radial-gradient(circle,rgba(239,68,68,0.35)_0%,transparent_70%)] opacity-40',
        icon: 'size-11'
    },
    variants: {
        state: {
            [StatePanelStates.Loading]: {
                ring: 'border-(--progress-glow,var(--purple-alpha-40))',
                delayedRing: 'border-(--progress-glow,var(--purple-alpha-40))',
                glow:
                    'bg-[radial-gradient(circle,var(--progress-glow,rgba(124,58,237,0.3))_0%,transparent_70%)] ' +
                    'opacity-35',
                icon:
                    'animate-state-panel-bob text-(--text-dark,var(--color-deep-space-blue-800)) ' +
                    'drop-shadow-(--state-icon-glow)'
            },
            [StatePanelStates.Error]: {
                icon: 'text-(--color-strawberry-red-400) drop-shadow-[0_0_0.75rem_rgba(239,68,68,0.4)]'
            },
            [StatePanelStates.Success]: {
                ring: 'border-(--accent-solid)/20',
                delayedRing: 'border-(--accent-solid)/12',
                glow: 'bg-[radial-gradient(circle,rgba(124,58,237,0.18)_0%,transparent_70%)]',
                icon: 'animate-state-panel-bob text-(--accent-solid) drop-shadow-(--state-icon-glow)'
            }
        }
    }
} satisfies ComponentTheme;
